// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"6614ae4b","163":"111f75ae","436":"d55e9264","453":"79629d33","472":"9e343186","473":"f171229c","952":"532b00f0","990":"9c7c57f5"}[chunkId] + ".chunk.js";
};